import SuperFetch from '../helpers/superFetch';
import UrlBuilder from '../helpers/urlBuilder';

const { build } = UrlBuilder;

type GetTeachers = (value: string) => Promise<Response>;
type SigninAsTeacher = (id: AppConfig.Teacher['prowadzacyPId']) => Promise<Response>;
type LogoutToSuperteacher = () => Promise<Response>;

/** 
 * Klasa zawiera metody służące wysyłaniu zapytań uwierzytelniających w kontekście przelogowywania na inne konto,
 * gdy użytkownik posiada rolę supernauczyciela oraz zapytań pobocznych
 * 
 */
class AuthAs {
  /** Zapytanie o listę nauczycieli */
  getTeachers: GetTeachers = (search: string) => {
    const address: string = build(`user/pracownicy`, { search });
    return SuperFetch.get(address);
  };
  /** Prośba o zalogowanie jako inny nauczyciel */
  signinAsTeacher: SigninAsTeacher = (id) => SuperFetch.post(`user/sign-as`, { id });
  /** prośba o wylogowanie z konta nauczyciela do konta supernauczyciela */
  logoutToSuperteacher: LogoutToSuperteacher = () => SuperFetch.post(`user/sign-out`);
}

export default new AuthAs();